import React from 'react'
import { useSelector } from 'react-redux';
import { teamScoresStyles as styles } from './teamScores.tailwind';

const TeamScores = () => {
  const { gameDetails } = useSelector(state => state.scorer);
  
  return (
    <div className={`${styles.outerContainer} ${gameDetails?.isGameEnded ? '' : 'w-full'}`}>
        {(gameDetails?.leagueSlug === 'mens-college-basketball' || gameDetails?.leagueSlug === 'womens-college-basketball') && (
          <div className={styles.genderBanner}>
            <span className={styles.genderText}>
              {gameDetails?.leagueSlug === 'mens-college-basketball' ? "MEN'S" : "WOMEN'S"}
            </span>
          </div>
        )}

        <div className={styles.scoreWrapper}>
          <div className={styles.teamDetailsContainer}>
              <img src={gameDetails?.homeTeamImage} alt={gameDetails?.homeTeamName} className={styles.image}/>
              <p className={styles.teamScore}>{gameDetails?.homeTeamScore}</p>
          </div>

          <div className={styles.time_versus}>
            <p className={styles.time_text}>{gameDetails?.currentSession}</p>
            <p className={styles.versusText} />
          </div>

          <div className={styles.teamDetailsContainer}>
              <p className={styles.teamScore}>{gameDetails?.awayTeamScore}</p>
              <img src={gameDetails?.awayTeamImage} alt={gameDetails?.awayTeamName} className={styles.image}/>
          </div>
        </div>
    </div>
  )
}

export default TeamScores